const createType = (perfix: string) => {
    return {
        REQUEST: perfix + '_REQUEST',
        SUCCESS: perfix + '_SUCCESS',
        FAILED: perfix + '_FAILED'
    };
};

export const GET_NOTICELIST_NAME = createType('GET_NOTICELIST_NAME');
export const GET_TYPE_NOTICELIST_NAME = createType('GET_TYPE_NOTICELIST_NAME');
export const GET_NOTICDETAIL_NAME = createType('GET_NOTICDETAIL_NAME');
export const PRAISE_NOTICE_META = createType('PRAISE_NOTICE_META');
export const CANCEL_PRAISE_NOTICE_META = createType('CANCEL_PRAISE_NOTICE_META');
export const ADD_NOTICE_COMMENT_META = createType('ADD_NOTICE_COMMENT_META');
export const DEL_NOTICE_COMMENT_META = createType('DEL_NOTICE_COMMENT_META');
export const HAS_NOTICE_PERMISSION_META = createType('HAS_NOTICE_PERMISSION_META');
export const UPDATE_NOTICE_VIEW_META = createType('UPDATE_NOTICE_VIEW_META');
